(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'Register'];

    function RegisterController ($translate, $timeout, Auth, LoginService, Register) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.exist = false;
        vm.existButton = true;
        vm.existButtonClass = '';
        vm.loginMouseleave = loginMouseleave;


        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }

        function loginMouseleave(){
            if (vm.registerAccount.login != '') {
                Register.query({loginId: vm.registerAccount.login}, function (result) {
                    if (result.id == undefined) {
                        vm.exist = false;
                        vm.existButton = false;
                        vm.existButtonClass = '';
                    } else {
                        vm.exist = true;
                        vm.existButton = true;
                        vm.existButtonClass = 'has-error';
                    }
                });
            } else {
                vm.exist = false;
                vm.existButton = false;
            }
        }
    }
})();
